{
  "label": "Sections",
  "open": "Open menu",
  "collapse": "Collapse menu",
  "expand": "Expand menu",
  "groups": {
    "project": "Project",
    "infrastructure": "Infrastructure",
    "services": "Services",
    "observe": "Observability",
    "org": "Organisation"
  },
  "switcher": {
    "caption": "Project",
    "title": "Choose a project",
    "search": "Find a project",
    "list": "Projects",
    "none": "Nothing found",
    "empty": "No projects yet",
    "new": "New project"
  },
  "overview": "Overview",
  "dashboard": "Dashboard",
  "servers": "Servers",
  "allServers": "All servers",
  "networking": "Network",
  "networks": "Private networks",
  "firewalls": "Firewalls",
  "ips": "Public IPs",
  "sshKeys": "SSH keys",
  "appsCatalogue": "Catalogue",
  "appsInstalled": "Installed",
  "kubernetes": "Kubernetes",
  "dns": "Domains and DNS",
  "monitoringServers": "Servers (Autopilot)",
  "projectSettings": "Project settings",
  "connection": "Provider connection",
  "catalogue": "Provider catalogue",
  "soon": "Soon",
  "soonHint": "“{{name}}” is coming soon",
  "projects": "All projects",
  "security": "Sign-in and security",
  "account": "Account",
  "theme": "Theme",
  "themes": {
    "system": "Like the system",
    "light": "Light",
    "dark": "Dark"
  },
  "images": "Snapshots and backups",
  "volumes": "Volumes",
  "floatingIps": "Floating IPs",
  "placementGroups": "Placement groups",
  "loadBalancers": "Load balancers",
  "certificates": "Certificates",
  "users": "Users",
  "projectAccess": "Members",
  "guestNotice": "You are a guest in this project: you can look at everything here, but not change it.",
  "apiAccess": "API and integrations",
  "apiKeys": "Keys",
  "apiPolicies": "Policies",
  "apiApps": "Connected apps",
  "messengers": "Messengers",
  "apiApprovals": "Approvals",
  "apiDocs": "API docs",
  "costs": "Costs",
  "orgCosts": "Organisation costs",
  "alerts": "Alerts",
  "monitoring": "Monitoring",
  "apps": "Apps"
}
